import { SET_HIDE_PREFERENCES_MODAL, SET_SHOW_PREFERENCES_MODAL } from "../../actions/preferences/preferences-modal-actions";

const initialState = {
    shoModalPreferences: false
};

const ShowModalPreferencesReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_SHOW_PREFERENCES_MODAL:
            return {
                ...state,
                error: null,
                shoModalPreferences : action.payload
            };
            case SET_HIDE_PREFERENCES_MODAL:
                return {
                    ...state,
                    error: null,
                    shoModalPreferences : action.payload
                };
        default:
            return state;
    }
};

export default ShowModalPreferencesReducer;